import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function uniqueDesignatedUnitNameFromListValidator(
  existingNames: string[],
  existingUnitName?: string
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const nameExists = existingNames.some(name => {
      if (existingUnitName && name === existingUnitName) {
        return false;
      }
      return name === control.value;
    });

    return nameExists ? { duplicateDesignatedUnitName: true } : null;
  };
}
